export default "__VITE_ASSET__vQgTrJM8__"